<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-map-marker-alt"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="location.name" field="name" /></FormRow>
      <FormRow label="Highlight Colour" helpTip="Highlight colour for the account location used with filtering">
        <FormColourTag v-model="location.highlightColour" field="highlightColour" />
      </FormRow>
      <FormHorizontalRule />
      <FormRow label="Address 1">
        <FormInputAddressSearch
          placeholder="Address Line 1"
          v-model="location.address1"
          field="address1"
          @updateAddress2="location.address2 = $event"
          @updateSuburb="location.suburb = $event"
          @updatePostcode="location.postcode = $event"
          @updateState="location.state = $event"
          @updateCountry="location.country = $event"
        />
      </FormRow>
      <FormRow label="Address 2"><FormInputText placeholder="Address 2" v-model="location.address2" field="address2" /></FormRow>
      <FormRow label="Suburb"><FormInputText placeholder="Suburb" v-model="location.suburb" field="suburb" /></FormRow>
      <FormRow label="State"><FormInputText placeholder="State" v-model="location.state" field="state" /></FormRow>
      <FormRow label="Postcode"><FormInputText placeholder="Postcode" v-model="location.postcode" field="postcode" /></FormRow>
      <FormRow label="Country"><FormInputText placeholder="Country" v-model="location.country" field="country" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="Email"><FormInputText placeholder="Contact Email" v-model="location.contactEmail" field="contactEmail" /></FormRow>
      <FormRow label="Phone"><FormInputText placeholder="Contact Phone" v-model="location.contactPhone" field="contactPhone" /></FormRow>
      <FormRow label="Fax"><FormInputText placeholder="Contact Fax" v-model="location.contactFax" field="contactFax" /></FormRow>
      <FormRow label="Website"><FormInputText placeholder="Website" v-model="location.contactWeb" field="contactWeb" /></FormRow>
      <FormHorizontalRule />
      <FormRow label="Labels"><FormLabelTag popupName="Location Labels" v-model="location.labelList" labelType="accountLocation" field="labelList" /></FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "AccountLocationEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      locationId: null,
      location: {
        labelList: []
      },
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Account Location' : 'Edit Account Location'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
  },
  methods: {
    show(location) {
      // Reset form
      this.location = {
        labelList: []
      }
      this.locationId = 0
      this.dialogForm = {}
      this.submitting = false

      if(location != null) {
        this.location = _.cloneDeep(location)
        this.locationId = location.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.location)
      updateData.labelList = updateData.labelList.map(label => label.id)

      if(this.isCreateMode) {
        this.$apiService.adminService.createAccountLocation(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateAccountLocation(this.locationId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>